<template>
    <div style="display: block; clear: both">
        <div style="display: flex; flex-direction: row;">
            <el-form-item 
                v-for="(categoryItems, categoryKey) in globals.categories"
                :label="names[categoryKey]" 
                :key="categoryKey"
                class="mr-5 pr-5"
                :class="requiredRule(categoryKey)"
                style="width: 200px;"
            >

                <el-checkbox-group v-model="tab_form.categories[categoryKey]" style="display: block; clear: both">
                    <el-checkbox v-for="(d, index) in categoryItems" :key="index" :label="index" class="d-block ml-0">
                        {{ d }}
                    </el-checkbox>
                    <el-checkbox label="undefined" class="d-block ml-0">Undefined</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'tab_form'
    ],
    data() {
        return {
            names: {
                driver: 'Job Category',
                equipment: 'Equiment Type',
                route: 'Driving Distance',
                teams: 'Teams',
                category: 'Specialization'
            },
        }
    },
    methods: {
        requiredRule(category) {
            return ['driver', 'equipment', 'teams'].includes(category) ? 'is-required' : '';
        },
    }
}
</script>